// MpAlert — aviso único em três níveis (info, warn, danger), com ação
// opcional à direita. Não substitui avisos/alerts existentes.
import React from "react";
import { radii } from "./tokens";

const LEVELS = {
  info:   { bg: "#E7F0FA", border: "#B5CFEA", fg: "#1F4E79" },
  warn:   { bg: "#FFF4E0", border: "#F2D59B", fg: "#8A5A00" },
  danger: { bg: "#FDECEC", border: "#F2B7B7", fg: "#A62424" },
};

export default function MpAlert({ level = "info", title, children, action }) {
  const t = LEVELS[level] || LEVELS.info;
  return (
    <div
      role="alert"
      data-testid={`mp-alert-${level}`}
      style={{
        background: t.bg,
        border: `1px solid ${t.border}`,
        color: t.fg,
        borderRadius: radii.card,
        padding: 12,
        display: "flex",
        gap: 12,
        alignItems: "flex-start",
        fontSize: 14,
      }}
    >
      <div style={{ flex: 1, minWidth: 0 }}>
        {title ? <div style={{ fontWeight: 600, marginBottom: 2 }}>{title}</div> : null}
        {children ? <div>{children}</div> : null}
      </div>
      {action ? <div style={{ flexShrink: 0 }}>{action}</div> : null}
    </div>
  );
}
